import React from 'react';
import classes from './loyaltyProgramSection.module.css';
import Title from '../../containers/title/title';
import Button from '../../containers/button/button';
import { useNavigate } from 'react-router';

const LoyalityProgram = (props) => {
    const navigate = useNavigate();
    const bookNowClicked = () => {
        if (!props.isAuthenticated) props.setShowLoginForm(true)
        else navigate('/field-booking')
    }
    return (
        <div className={classes.LoyalityProgram}>
            <Title title={props.loyaltySection?.title} />
            <div className={classes.Container}>
                <p>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "1JD = 10 Points" 
                        : "١ دينار = ١٠ نقاط"}
                </p>
                <p dangerouslySetInnerHTML={{ __html: props.loyaltySection?.content}}/>
                <p>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "Applicable to all services" 
                        : "يسري على جميع الخدمات"}
                </p>
                <Button 
                    content={parseInt(localStorage.getItem('language')) === 1 ? "BOOK NOW" : "احجز الآن"}
                    onClick={bookNowClicked}
                    whiteBackground
                />
            </div>
        </div>
    )
}
export default LoyalityProgram;